import { SagaIterator } from 'redux-saga';
import { put, select } from 'redux-saga/effects';
import { SEARCH_ACTIONS } from 'src/actions/SearchActions';
import { SUGGEST_ACTIONS } from 'src/actions/SuggestActions';
import { SearchParams } from 'src/state/SearchParams';
import { getUrlQueryParams } from 'src/selectors/getUrlQueryParams';

export function* locationSaga(): SagaIterator {
    const params: SearchParams = yield select(getUrlQueryParams);
    yield put(SEARCH_ACTIONS.request(undefined, params));
    yield put(SUGGEST_ACTIONS.request(undefined, params.query));
}
